import Common from 'js/_core/Common'
import StepForm from 'js/contact/cf7/StepForm'

import ViewController from 'js/app/controllers/ViewController'
import { gsap } from 'gsap'

export default class ContactHomeViewController extends ViewController {
  constructor(content) {
    super(content)
    if (this.debug) {
      this.pageName = '[ContactHome]'
    }

    // ページ別のコンテンツ(html)はここからアクセスできます
    this.$content = content
    // this.stepForm = new StepForm({
    //   $content: this.$content,
    // })
  }

  async willLoad() {
    await super.willLoad()
  }

  async didLoad() {
    await super.didLoad()
  }

  async beforeEnter() {
    await super.beforeEnter()
    // this.stepForm?.init()
  }

  async enter() {
    this.addHandlers()
    await super.enter()
    this._addObservers()
    this._setLayout()
    if (Common.webgl) {
      gsap.delayedCall(0.2, () => {
        // Common.webgl.fvAnimation({
        //   pageId: 'CareerHome',
        // })
      })
    }
  }

  async afterEnter() {
    await super.afterEnter()
  }

  async beforeLeave() {
    await super.beforeLeave()
    this._removeObservers()
    this.removeHandlers()
  }

  async leave() {
    await super.leave()
  }

  async afterLeave() {
    await super.afterLeave()
  }

  _set$() {
    super._set$()
  }

  addHandlers() {
    super.addHandlers()
    if (Common.resize) {
      Common.resize.addHandler(() => {
        this.onResize()
      }, 'ContactHomeControllerResize')
    }
  }

  removeHandlers() {
    super.removeHandlers()
    if (Common.resize) {
      Common.resize.removeHandler('ContactHomeControllerResize')
    }
  }

  _addObservers() {}

  _removeObservers() {}

  _setLayout() {
    if (!Common.detection.isMobileLayout) {
    }
  }

  onResize() {
    super.onResize()
    this._setLayout()
  }
}